<template>
  <h1 class="hr-main fs-4 fw-normal mb-3">
    {{ filter === 'my' ? t('myOrders') : t('ordersRequiringAction') }}
  </h1>
  <OTable
    :initial="lm"
    @list-query="syncQuery"
    :pagination="true"
    :loading="loading"
    :page-size-options="[5, 10, 20, 50]"
    :persist-key="persistKey"
  />
</template>

<script setup>
import { ref, reactive, computed, watch, provide } from 'vue'
import { commons } from '@/lib/transformer'
import { useApi } from '@/composables/api'
import OTable from '@/views/orders/list/table.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps({
  filter: {
    type: String,
    default: 'my',
  },
  modalstack: {
    type: Boolean,
    default: false,
  },
  persistKey: {
    type: String,
    default: '',
  },
})

const lm = ref({ onPage: 5, page: 1 })

const query = reactive({
  order_field: 'date_created',
  order_direction: 'DESC',
  filter: '',
  filter_id: '',
  search: '',
  onPage: 5,
  page: 1,
})

const apiQuery = computed(() => {
  const base = {
    filter: query.filter,
    filter_id: query.filter_id,
    onPage: query.onPage,
    page: query.page,
    ...(query.search ? { search: query.search } : {}),
    ...(props.filter ? { [props.filter]: true } : {}),
  }

  if (query.filter === '' && query.filter_id === '') {
    return {
      ...base,
      order_field: query.order_field,
      order_direction: query.order_direction,
    }
  }

  return base
})

const {
  model,
  refresh,
  pending: loading,
} = useApi({
  url: 'orders',
  data: { data: [], total_count: 0 },
  query: apiQuery,
  pick: d => {
    const _d = (d.data || []).map(d => {
      if (d.date_created) d.fmt_date_created = commons.dateLocal(d.date_created, 'Pp')
      return d
    })
    return { data: _d, total_count: d.total_count ?? _d.length }
  },
})
provide('model', model)
provide('refresh', refresh)

function syncQuery(val) {
  lm.value = val
}

watch(
  lm,
  val => {
    Object.assign(query, val)
    refresh()
  },
  { immediate: true }
)

defineEmits(['modalstack:close'])
</script>

<i18n>
{
  "ru": {
    "myOrders": "Мои заявки",
    "ordersRequiringAction": "Заявки, требующие от Вас действия"
  },
  "en": {
    "myOrders": "My orders",
    "ordersRequiringAction": "Orders requiring your action"
  }
}
</i18n>
